import React from 'react';

const Hero = () => {
  return (
    <section className="bg-[#3b7ba8] pt-24 pb-12 lg:pb-0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-8">
          {/* Text Content */}
          <div className="flex-1 text-white space-y-6 lg:pr-12">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight">
              Flavor and health <br />in perfect balance.
            </h1>
            <p className="text-lg md:text-xl text-gray-100">
              Choose a tastier and healthier life with Sweet Life diet candies.
            </p>
          </div>

          {/* Hero Image */}
          <div className="flex-1 w-full">
            <img 
              src="https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=800&q=80"
              alt="Healthy lifestyle" 
              className="w-full h-auto rounded-lg shadow-2xl object-cover max-h-[500px]"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
